<!--
  ~ Copyright (c) 1999 - 2020 Accorto, Inc. - All rights reserved.
  -->

<header class="slds-page-header">
  <div class="slds-page-header__row">
    <div class="slds-page-header__col-title">
      <div class="slds-media">
        <div class="slds-media__figure">
          <span class="slds-icon_container slds-icon-standard-groups" title="Calendar">
            <svg aria-hidden="true" class="slds-icon slds-page-header__icon">
              <use xlink:href="/assets/icons/standard-sprite/svg/symbols.svg#date_input"></use>
            </svg>
            <span class="slds-assistive-text">Calendar</span>
          </span>
        </div>
        <div class="slds-media__body">
          <div class="slds-page-header__name">
            <div class="slds-page-header__name-title">
              <h1>
                <span class="slds-page-header__title slds-truncate" title="Calendar">Project and Resource Calendar</span>
              </h1>
            </div>
          </div>
          <p class="slds-page-header__name-meta"></p>
        </div>
      </div>
    </div>
    <div class="slds-page-header__col-actions">
      <div class="slds-page-header__controls">
        <div class="slds-page-header__control">
          <div class="slds-avatar slds-m-right_small">
            <img *ngIf="busy" alt="Loading ..." id="busy" src="/assets/images/busy.svg" title="Loading ...">
          </div>

          <button (click)="doRefresh()"
                  class="slds-button slds-button_icon slds-button_icon-border"
                  id="ps-refresh" title="Refresh">
            <svg aria-hidden="true" class="slds-button__icon">
              <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#refresh"></use>
            </svg>
            <span class="slds-assistive-text" i18n>Refresh</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="slds-page-header__row slds-page-header__row_gutters">
    <div class="slds-page-header__col-details">
      <ul class="slds-page-header__detail-row">
        <li class="slds-page-header__detail-blockX">
          <h3 class="slds-text-heading_small" i18n>Resource Restriction</h3>
          <psa-resource-search (resourceRestriction)="onResourceRestriction($event)"></psa-resource-search>
        </li>
      </ul>
      <!-- ul class="slds-page-header__detail-row">
        <li class="slds-page-header__detail-blockX">
          <h3 class="slds-text-heading_small" i18n>Project Restriction</h3>
        </li>
      </ul -->
    </div>
  </div>

</header>


<aside class="slds-m-vertical_medium">
  <button (click)="onMonthPrevious($event)"
          class="slds-button slds-button_icon slds-button_icon-border-filled"
          i18n-title title="Previous Month">
    <svg aria-hidden="true" class="slds-button__icon">
      <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#left" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
    </svg>
    <span class="slds-assistive-text" i18n>Previous Month</span>
  </button>

  <div class="slds-m-horizontal_large slds-show_inline-block">
    <div class="slds-select_container">
      <select #theMonth (change)="onMonthChange($event)" class="slds-select" id="month" style="font-size: larger">
        <option *ngFor="let m of monthList" [value]="m.index">{{m.label}}</option>
      </select>
    </div>
  </div>

  <button (click)="onMonthNext($event)"
          class="slds-button slds-button_icon slds-button_icon-border-filled"
          i18n-title title="Next Month">
    <svg aria-hidden="true" class="slds-button__icon">
      <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#right" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
    </svg>
    <span class="slds-assistive-text" i18n>Next Month</span>
  </button>

  <div class="slds-m-left_medium slds-show_inline-block">
    <acc-status-line [error]="error" [message]="message"></acc-status-line>
  </div>
</aside>


<section>
  <table>
    <tr *ngFor="let week of weeks" class="cal-week">
      <td *ngFor="let day of week.days"
          [class.calendar-day-weekend]="day.isWeekend"
          class="calendar-day">
        <div class="calendar-day-content">
          <time [dateTime]="day.dateTime" style="font-family: serif">{{day.label}}</time>
          <article>
            <div *ngFor="let line of day.lines"
                 [class.calendar-alloc-capacity]="line.isCapacity"
                 [class.calendar-alloc-over]="line.isOver">
              {{line.hours}}h - {{line.resourceName}} -
              <small>{{line.projectName}}</small>
            </div>
          </article>
        </div>
      </td>
    </tr>
  </table>
</section>
